// ----- Phase phase-ui-consistency-sweep (§3C) — ONE button style -----
//
// Before this phase every screen rolled its own inline `<button style={…}>`,
// so primary / secondary / destructive buttons drifted visually from page
// to page (e.g. the Submission Detail "Edit" button used a one-off
// outline style that matched nothing else). This component gives a single
// shared set of variants so buttons look identical wherever they appear.
// Links that must look like buttons reuse `buttonStyle()` from
// `./buttonStyle`.

import type { ButtonHTMLAttributes, ReactElement } from 'react';
import { buttonStyle, type ButtonVariant, type ButtonSize } from './buttonStyle';

export type { ButtonVariant, ButtonSize } from './buttonStyle';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly size?: ButtonSize;
}

export function Button({
  variant = 'primary',
  size = 'md',
  style,
  disabled = false,
  type = 'button',
  ...rest
}: ButtonProps): ReactElement {
  return (
    <button
      type={type}
      disabled={disabled}
      style={{ ...buttonStyle(variant, size, disabled), ...style }}
      {...rest}
    />
  );
}
